import { render, staticRenderFns } from "./VxTreeSelect.vue?vue&type=template&id=3bb27583"
import script from "./VxTreeSelect.vue?vue&type=script&lang=js"
export * from "./VxTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports